class CollageVideo extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeWhenReady();
    }

    async initializeWhenReady() {
      await customElements.whenDefined('low-power-video');
      await new Promise(resolve => setTimeout(resolve, 100));

      this.playPauseButton = this.querySelector('.shoppable-video__control-button');
      this.video = this.querySelector('video');
      this.lowPowerVideo = this.querySelector('low-power-video');
      
      if (this.playPauseButton && this.video) {
        this.playPauseButton.addEventListener('click', this.handlePlayPause.bind(this));
        this.video.addEventListener('play', () => {
          console.log('play');
          this.playPauseButton.classList.add('is-playing');
          this.playPauseButton.querySelector('.shoppable-video__icon-play').style.display = 'none';
          this.playPauseButton.querySelector('.shoppable-video__icon-pause').style.display = 'block';
          // Unmute video when playing
          this.video.muted = false;
        });
        this.video.addEventListener('pause', () => {
          console.log('pause');
          this.playPauseButton.classList.remove('is-playing');
          this.playPauseButton.querySelector('.shoppable-video__icon-play').style.display = 'block';
          this.playPauseButton.querySelector('.shoppable-video__icon-pause').style.display = 'none';
        });

        // Initialize play/pause button state
        if (this.video.paused) {
          this.playPauseButton.querySelector('.shoppable-video__icon-play').style.display = 'block';
          this.playPauseButton.querySelector('.shoppable-video__icon-pause').style.display = 'none';
        } else {
          this.playPauseButton.querySelector('.shoppable-video__icon-play').style.display = 'none';
          this.playPauseButton.querySelector('.shoppable-video__icon-pause').style.display = 'block';
        }
      }
    }

    handlePlayPause() {
      if (!this.video) return;
      
      if (this.video.paused) {
        this.video.play();
        this.lowPowerVideo.setAttribute('playing', '');
      } else {
        this.video.pause();
        this.lowPowerVideo.removeAttribute('playing');
      }
    }
  }

  customElements.define('collage-video', CollageVideo);